import { axiosInstance } from "apps/t2c-fe/utils";

interface GetUpdatedCaptionBrollJsonRequest {
    jsonId: string;
}
  
export const getUpdatedCaptionBrollJson = async (
  payload: GetUpdatedCaptionBrollJsonRequest
): Promise<any> => {
  const resp = await axiosInstance.post('/api/broll/get-json', payload);
  return resp.data;
};
